<template>
  <div class="banner__layout banner_mobile">
    <div class="banner__banner banner_main">
      <div class="banner__left">
        <img src="@/assets/images/QDLOp3qTiVzuezlhsT44y.svg" alt />
      </div>
      <div class="banner__promo">
        <h1>{{ $t("MOBILEAPP.BANNER_1.TITLE") }}</h1>
        <p>{{ $t("MOBILEAPP.BANNER_1.SUBTITLE") }}</p>
        <div class="banner__promo-extra">
          <a href="https://apps.apple.com/kz/app/helpcenter-life/id1523269014">
            <img src="@/assets/images/mobile/appstore.png" alt />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.helpcenter"
          >
            <img src="@/assets/images/mobile/googleplay.png" alt />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileBanner"
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.banner {
  &__promo {
    display: flex;
    flex-direction: column;
    flex-basis: 50%;

    &-extra {
      display: flex;
      margin: 20px 0 0;

      a + a {
        margin: 0 0 0 10px;
      }
    }
  }

  &__left {
    img {
      width: 80%;
      margin: 0 auto;
    }
  }

  @media screen and (min-width: $min-lg) {
    &__promo {
      padding: 0 30px;

      h1 {
        margin: 30px 0 10px;
      }
    }
  }

  @media screen and (max-width: $max-md) {
    &__promo {
      h1 {
        font-size: 26px;
      }
    }
  }
}
</style>
